document.addEventListener('DOMContentLoaded', () => {
  const body = document.querySelector('body');

  const hamburger = document.querySelector('.js_hamb');
  const nav = document.querySelector('.js_nav');

  const headerSompo = document.querySelector('.bl_header_sompo');
  const headerInfo = document.querySelector('.bl_header_info');
  const headerMain = document.querySelector('.bl_header_main');

  if (hamburger && nav) {
    hamburger.addEventListener('click', () => {
      if (nav.classList.contains('isOpened')) {
        nav.classList.remove('isOpened');
        hamburger.classList.remove('isOpened');
        body.classList.remove('noScroll');
      } else {
        let paddingTop = headerMain.offsetHeight;
        const isHeaderInfoInView = headerInfo.getBoundingClientRect().bottom > 0;
        const isHeaderSompoInView = headerSompo.getBoundingClientRect().bottom > 0;
        if (isHeaderInfoInView) {
          paddingTop += headerInfo.offsetHeight;
        }
        if (isHeaderSompoInView) {
          paddingTop += headerSompo.offsetHeight;
        }
        nav.classList.add('isOpened');
        nav.style.paddingTop = `${paddingTop}px`;
        hamburger.classList.add('isOpened');
        body.classList.add('noScroll');
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 767) {
        nav.classList.remove('isOpened');
        hamburger.classList.remove('isOpened');
        body.classList.remove('noScroll');
      }
    });
  }

  function fixHeaderToTop() {
    const isHeaderInfoInView = headerInfo.getBoundingClientRect().bottom > 0;

    if (!isHeaderInfoInView) {
      if (!headerMain.classList.contains('isFixed')) {
        var computedStyle = window.getComputedStyle(headerMain);
        headerMain.classList.add('isFixed');
        headerInfo.style.marginBottom = '0';
      }
    } else {
      if (headerMain.classList.contains('isFixed')) {
        headerMain.classList.remove('isFixed');
        headerInfo.style.marginBottom = `${headerMain.offsetHeight + parseInt(computedStyle.marginBottom, 10)}px`;
      }
    }
  }

  const fixedSection = document.querySelector('.js_info_fixed');
  const toTopBtn = document.querySelector('.js_toTopBtn');

  function showFixedSection() {
    const headerInfo = document.querySelector('.bl_header_info');
    const headerInfoRect = headerInfo.getBoundingClientRect();
    const isHeaderInfoInView = headerInfoRect.bottom > 0;
    if (!isHeaderInfoInView) {
      fixedSection.classList.add('isActive');
    } else {
      fixedSection.classList.remove('isActive');
    }
  }

  if (fixedSection) {
    if (toTopBtn) {
      toTopBtn.addEventListener('click', () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      });
    }
    window.addEventListener('scroll', showFixedSection);
  }

  const navSubmenu = document.querySelector('.bl_nav_main_links_sub');
  const navSubmenuBtn = document.querySelector('.js_navSubmenu');
  navSubmenuBtn.addEventListener('click', () => {
    navSubmenuBtn.classList.toggle('isOpen');
    navSubmenu.classList.toggle('isOpen');
  });

  window.addEventListener('scroll', fixHeaderToTop);
  fixHeaderToTop();
  showFixedSection();
});
